import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import theme from "theme";
import SC from "./style";

const ProjectSection = ({ items, title, onSelectionChange, selectedItems }) => {
  const [selectAll, setSelectAll] = useState(false);
  const [filteredItems, setFilteredItems] = useState(items);

  // Sync filtered items with main items
  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  // Update selectAll checkbox state
  useEffect(() => {
    const isAllSelected =
      selectedItems.length > 0 && selectedItems.length === items.length;
    setSelectAll(isAllSelected);
  }, [selectedItems, items.length]);

  // Toggle select all
  const handleSelectAllChange = () => {
    const newState = !selectAll;
    setSelectAll(newState);

    if (newState) {
      const allIds = filteredItems.map((item) => item.id);
      onSelectionChange(allIds, true);
    } else {
      onSelectionChange("clear", false);
    }
  };

  // Filter holidays by holidayName
  const handleSearch = (event) => {
    const query = event.target.value.trim().toLowerCase();
    if (query === "") {
      setFilteredItems(items);
    } else {
      const results = items.filter(
        (item) =>
          item.holidayName && item.holidayName.toLowerCase().includes(query)
      );
      setFilteredItems(results);
    }
  };

  return (
    <Box>
      {items.length === 0 ? (
        <Typography
          sx={{
            padding: "20px",
            textAlign: "center",
            fontSize: "14px",
            color: theme.colors.grey,
          }}
        >
          No holiday linked
        </Typography>
      ) : (
        <>
          {title && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "left" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                      sx={{
                        "&.Mui-checked": {
                          color: theme.colors.themeColor,
                        },
                      }}
                      size="small"
                    />
                  }
                  label={<span style={{ fontWeight: "bold" }}>{title}</span>}
                />
              </Typography>

              <SC.InputContiner>
                <SC.SearchIcon />
                <SC.InputStyle
                  placeholder="Search by holiday name"
                  onChange={handleSearch}
                />
              </SC.InputContiner>
            </Box>
          )}

          <Divider />

          <List sx={{ display: "flex", flexDirection: "column" }}>
            {filteredItems.map((item) => (
              <ListItem key={item.id} disablePadding>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedItems.includes(item.id)}
                        onChange={() => onSelectionChange(item.id)}
                        sx={{
                          "&.Mui-checked": {
                            color: theme.colors.themeColor,
                          },
                        }}
                        size="small"
                      />
                    }
                    label={
                      <span style={{ fontSize: "12px" }}>
                        {item?.holidayName} &nbsp;({item?.startDate} -{" "}
                        {item?.endDate})
                      </span>
                    }
                  />
                </FormGroup>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default ProjectSection;
